import React from 'react'
import styled from 'styled-components';
import { injectIntl, FormattedHTMLMessage } from 'gatsby-plugin-intl';
import pyramidVideo from '../images/equipment/pyramid.mp4';

import H3 from './styledComponents/H3';
import IdeaGeneral from './styledComponents/IdeaGeneral';
import ChapterSpace from './styledComponents/ChapterSpace';

import { Container,Cell,Grid,AnchorBlock,ChapterHeader,ParentAnchor } from './blockComponents';
import { PlainImage } from './imageComponents';

const Video = styled.video`
    width: 100%;
    outline: 0;
`;

function Equipment({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {
    return (
        <ParentAnchor
            key='equipmentSection'
            blockId="equipment-section"
            blockName='equipmentSection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'MainMenu_8' })} downloadLink="https://drive.google.com/drive/folders/1fAZGAl4g2t7AvwV6x_-8FfSkS5fjNztI?usp=sharing"></ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <IdeaGeneral space="Top">
                            <FormattedHTMLMessage id="stand_1" />
                        </IdeaGeneral>
                        <AnchorBlock
                            key='wallStandsBlock'
                            blockName='wallStandsBlock'
                            blockId='wall-stands'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'stand_1_1' })}</H3>
                            <PlainImage src="equipment/ajax_stand_groups@2x.jpg" alt="" />
                            <Grid>
                                <Cell col={6}>
                                    <PlainImage src="equipment/wallstand-3@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="equipment/wallstand-2@2x.jpg" alt="" />
                                </Cell>
                            </Grid>
                            <PlainImage src="equipment/bw-gorisontal@2x.jpg" last="xs" alt="" />
                        </AnchorBlock>
                        <AnchorBlock
                            key='lstandBlock'
                            blockName='lstandBlock'
                            blockId='l-stand'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'stand_1_2' })}</H3>
                            <PlainImage src="equipment/l-stand-1@2x.jpg" alt="" />
                            <Grid>
                                <Cell col={6}>
                                    <PlainImage src="equipment/l-stand-2@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="equipment/l-stand-3@2x.jpg" alt="" />
                                </Cell>
                            </Grid>
                            <PlainImage src="equipment/pyramid-3@2x.jpg" alt="" />
                            <Video autoPlay muted loop playsInline tabindex="0">
                                <source src={pyramidVideo} type="video/mp4" />
                            </Video>
                        </AnchorBlock>
                        <AnchorBlock
                            key='standsBlock'
                            blockName='standsBlock'
                            blockId='stands'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'stand_1_4' })}</H3>
                            <PlainImage src="equipment/space-1@2x.jpg" alt="" />
                            <PlainImage src="equipment/Space2@2x.jpg" last="xs" alt="" />
                        </AnchorBlock>
                    </Cell>
                </Grid>
            </Container>
            <ChapterSpace />
        </ParentAnchor>
    )
}

export default injectIntl(Equipment)